import apiVersions from './version/apiVersions.json';

const generateApiRoutes = (endpoint) => ({
  dashboard: `${endpoint}/stats/${apiVersions.stats}/dashboard`,
  dashboards: `${endpoint}/stats/${apiVersions.stats}/dashboards`,
  reports: `${endpoint}/stats/${apiVersions.stats}/reports`,
  filterData: `${endpoint}/stats/${apiVersions.stats}/filterData`,
  reportData: `${endpoint}/stats/${apiVersions.stats}/report/:reportId/data`,
  login: `${endpoint}/userLogin/${apiVersions.userLogin}/login`,
  venueContext: `${endpoint}/userLogin/${apiVersions.userLogin}/venueContext`,
  logout: `${endpoint}/userLogin/${apiVersions.userLogin}/logout`,
  userConfig: `${endpoint}/userLogin/${apiVersions.userLogin}/configuration`,
  setLanguageUser: `${endpoint}/userLogin/${apiVersions.userLogin}/languageSet`,
  setLanguage: `${endpoint}/core/${apiVersions.core}/languageSet`,
  start: `${endpoint}/core/${apiVersions.core}/sessionStart`,
  app: `${endpoint}/appdefinitions/${apiVersions.appdefinitions}/app`,
  menu: `${endpoint}/appdefinitions/${apiVersions.appdefinitions}/menus`,
  datasets: `${endpoint}/appdefinitions/${apiVersions.appdefinitions}/datasets`,
  filters: `${endpoint}/appdefinitions/${apiVersions.appdefinitions}/filters`,
  forms: `${endpoint}/appdefinitions/${apiVersions.appdefinitions}/forms`,
  layoutDefinitions: `${endpoint}/appdefinitions/${apiVersions.appdefinitions}/layouts`,
  styles: `${endpoint}/appdefinitions/${apiVersions.appdefinitions}/styles`,
  guides: `${endpoint}/appdefinitions/${apiVersions.appdefinitions}/guides`,
  tours: `${endpoint}/appdefinitions/${apiVersions.appdefinitions}/tours`,
  paths: `${endpoint}/appdefinitions/${apiVersions.appdefinitions}/paths`,
  guideProgress: `${endpoint}/webManager/1.0/guides/progress`,
  quickBookmarks: `${endpoint}/webManager/1.0/quick-bookmarks`,
  defaultCurrency: `${endpoint}/settings/${apiVersions.settings}/defaultCurrency`,
  defaultFormats: `${endpoint}/settings/${apiVersions.settings}/defaultFormats`,
});

const apiEndpoints = {
  basePath: '',
  routes: generateApiRoutes(''),
};

export const updateApiEndpoint = (newEndpoint) => {
  apiEndpoints.basePath = newEndpoint;
  apiEndpoints.routes = generateApiRoutes(newEndpoint);
};

export default apiEndpoints;
